export default {"src":"/_next/static/media/android.573659de.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};